import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PatientService } from '../../../../core/services/v2/patient.service';


@Component({
  selector: 'app-patient-photo-edit',
  templateUrl: './patient-photo-edit.component.html',
  styleUrls: ['./patient-photo-edit.component.scss']
})
export class PatientPhotoEditComponent implements OnInit {
  patientId: number;
  photoUrl: string;
  headerText: string;
  @ViewChild('profilepicedit', { static: true }) fileInput;
  constructor(
    private patienteService: PatientService,
    public dialogRef: MatDialogRef<PatientPhotoEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.patientId = data.pid;
      this.photoUrl = data.urlPhoto;

    }
    if (this.photoUrl) {
      this.headerText = (data.preferredName ? data.preferredName : "Hi") + ", keep your profile fresh!";
    } else {
      this.headerText = (data.preferredName ? data.preferredName : "Hi") + ", your profile is not fresh!";
    }
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(this.photoUrl);
  }

  add(): void {
    const pid = this.patientId;
    const fi = this.fileInput.nativeElement;

    if (fi.files && fi.files[0]) {
      const fileToUpload = fi.files[0];
      this.patienteService.uploadPatientEditPicture(pid, fileToUpload).subscribe(
        (_) => { this.dialogRef.close(this.photoUrl); },
        (error) => { console.error(error); }
      );
    }
  }


}
